import { AfterViewInit, Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ActivatedRoute} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ImageModalComponent} from '../../../core/components/dialogs/image-modal/image-modal.component';
import { NgForm } from '@angular/forms';
import {EventService} from '../../../core/services/event.service';
import { HybridToolsService } from '../../../core/services/hybrid-tools.service';
import {ImageService} from '../../../core/services/image.service';
import {Angulartics2} from 'angulartics2';
import {PostService} from '../../../core/services/post.service';
// import {CKEditorComponent} from "ng2-ckeditor/ckeditor.component";

@Component({
    selector: 'app-edit-post',
    templateUrl: './edit-post.html',
    styleUrls: ['./edit-post.scss']
})
export class EditPostComponent implements AfterViewInit, OnDestroy, OnInit {
    @ViewChild('postEditor') postEditor: any;
    @ViewChild('form', { static: true }) form: NgForm;

    @Input() post: any = {};
    @Input() pagePosts: any;
    state: any = {
        isSubmitted: false
    };

    @Output() onInit: EventEmitter<NgForm> = new EventEmitter();
    @Output() onEditCancel: EventEmitter<any> = new EventEmitter();
    @Output() onEditSave: EventEmitter<any> = new EventEmitter();

    showFiles: any;

    public isMobile = false;
    public saving: boolean;
    public ckeditorDesktopConfig = {
        uiColor: '#e4e9f0',
        extraPlugins: 'resize,divarea',
        allowedContent: true,
        resize_enabled: true,
        linkShowTargetTab: false,
        linkShowAdvancedTab: false,
        height: 300,
        removeDialogTabs: 'link:target;link:advanced',
        toolbar: [
            { name: 'buttons', items: [ 'Source', 'Preview', 'Print', 'Cut',
                'Copy', 'Paste', 'PasteFromWord', 'Undo', 'Redo', 'Bold', 'Italic', 'CopyFormatting', 'JustifyLeft', 'JustifyCenter',
                'JustifyRight', 'JustifyBlock', 'Link', 'Unlink', 'image', 'VideoEmbed', 'Table', 'Font', 'FontSize'] },
        ]
    };
    public ckeditorMobileConfig = {
        uiColor: '#e4e9f0',
        extraPlugins: 'resize,divarea',
        allowedContent: true,
        resize_enabled: true,
        height: 300,
        removeDialogTabs: 'link:target;link:advanced',
        toolbar: [
            { name: 'buttons', items: [ 'Undo', 'Redo', 'Bold', 'Italic', 'CopyFormatting', 'JustifyLeft', 'JustifyCenter',
                'JustifyRight', 'JustifyBlock', 'image', 'VideoEmbed', 'Font', 'FontSize'] },
        ]
    };


    constructor(
        private http: HttpClient,
        private route: ActivatedRoute,
        private ToastrService: ToastrService,
        public modalService: NgbModal,
        private eventService: EventService,
        private imageService: ImageService,
        private ngZone: NgZone,
        private angulartics2: Angulartics2,
        private postService: PostService,
        private hybridToolsService: HybridToolsService
    ) {}

    ngOnInit() {
        this.initCkeditorConfig();
    }

    ngAfterViewInit() {
        this.onInit.emit(this.form);

        window.onresize = (e) => {
            // ngZone.run will help to run change detection
            this.ngZone.run(() => {
                this.initCkeditorConfig();
            });
        };
        this.updateLinks();
    }

    ngOnDestroy() {
        window.onresize = null;
    }

    initCkeditorConfig() {
        // TODO: may want to update this
        if (window.innerWidth < 767) {
            this.isMobile = true;
        } else {
            this.isMobile = false;
        }
    }

    updateLinks() {
        /* Disabling due to FUND-1185 and FUND-1186.  This does mean that the user won't be able to click links in the
         * wysiwyg editor and have those links open
         */
        /*
        setTimeout(() => {
            const that = this;
            $('.editor-wrapper a').each(function (item) {
                $(this).attr('data-link', $(this).attr('href')).removeAttr('href');
                $(this).addClass('link');
                $(this).bind('click', function () {
                    that.hybridToolsService.openExternalLink($(this).attr('data-link'));
                });
            });
        }, 100)
         */
    }

    openImageExplorer() {
        const imageModal = this.modalService.open(ImageModalComponent); // open pop-up window
        imageModal.result.then(result => {
            this.postEditor.instance.insertHtml(
                '<img style=\'max-width: 100%;\' src=\'' + result.imagePath + '\'/>'
            );
        }, () => {/* avoids error on 'cancel' */});
    }

    cancel() {
        this.onEditCancel.emit();
    }

    save(isPublished) {
        this.saving = true;
        this.state.isSubmitted = true;
        if (!this.form.valid) {
            window.scrollTo(0, 0);
            this.saving = false;
            return;
        } else {
            if (!this.post.html) {
                this.ToastrService.error('Please add post content.');
                this.saving = false;
                return;
            }

            const baseUrl = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.baseUrl
            let htmlContent = '';
            if (this.post.html) {
                htmlContent = this.post.html.replace(this.imageService.getUpdateImageRegex(baseUrl), '$1' + '$3');
            }

            const payload = {
                title: this.post.title,
                htmlContent: htmlContent,
                urlKey: this.postService.generatePostUrlKey(this.post.title, this.pagePosts),
                published: isPublished
            };

            this.form.form.markAsPristine();
            if (this.post.postId) {
                this.http.post('/api/v1/posts/' + this.post.postId, payload).subscribe(
                () => {
                        this.onEditSave.emit();
                        this.ToastrService.success('Post updated.');
                        this.saving = false;
                    },
                    err => {
                        const error = JSON.parse(err['error']);
                        if (error && !!error.fieldErrors) {
                            const errors = [];
                            errors.push
                                (error.fieldErrors.map(function (item, index) { return item.message; })
                            );
                            this.ToastrService.error(errors.join(', '));
                        } else {
                            this.ToastrService.error('There was a problem updating your post');
                        }
                        this.saving = false;
                    }
                );
            } else {
                this.http.post('/api/v1/pages/' + this.route.snapshot.params['pageID'] + '/posts', payload).subscribe(() => {
                    this.onEditSave.emit();
                    this.ToastrService.success('Post created.');
                    this.angulartics2.eventTrack.next({
                        action: 'Create Post',
                        properties: {category: 'Fundraising Pages: Posts'}
                    });
                    this.saving = false;
                }, err => {
                    const error = JSON.parse(err['error']);
                    if (error && !!error.fieldErrors) {
                        const errors = [];
                        errors.push(error.fieldErrors.map(function (item, index) {
                            return item.message;
                        }));
                        this.ToastrService.error(errors.join(', '));
                    } else {
                        this.ToastrService.error('There was a problem saving your post');
                    }
                    this.saving = false;
                });
            }
        }
    }
}
